import * as React from "react";
import { VBox, HBox } from "framework/structural_components/hbox_vbox";
import { Button, ButtonMinus, Intent } from "framework/controls/button";
import { useCompetitionRegistration } from "../store";
import { cls_bold, cls_colorGrey90, cls_colorMagenta60, cls_colorOrange50, cls_gap_form, cls_p5r, cls_visibility_hidden } from "style/index.css";
import { cls_align_items_center, cls_align_items_flex_start, cls_justify_content_flex_end, cls_justify_content_space_between } from "framework/structural_components/hbox_vbox.css";
import { Checkbox } from "framework/controls/checkbox";
import { getAllowedAgeIdsForTeamOrFormationMembers, getAllowedAgeIdsForGroupMembers, getAllowedNumberOfOlderPeopleInGroup, getAllowedOlderAgeIdsForGroupMembers } from "public_app/view/entity";
import { toSingleString } from "framework/validation/strings";
import { CompetitionType, CompetitorType } from "public_app/events/entity";
import { Dialog, DialogContent, DialogTitle } from "framework/dialog/dialog";
import { cls_1px_width, cls_asterisk_box, cls_dialog_content_width, cls_dialog_vertical_division_line, cls_flex_fixed_size, cls_flex_use_available_space, cls_list_height, cls_overflowY_auto, cls_submembers_dialog_subcontent, cls_width_athlete_name, cls_width_captain, cls_width_checkbox, cls_width_column_available_athletes, cls_width_column_available_athletes_item, cls_width_column_backup, cls_width_column_group_members_list, cls_width_column_group_members_list_item, cls_width_delete } from "./view.css";
import { useif } from "framework/state/types";
import { TextField } from "framework/controls/text_field";
import { LoadingSpinner } from "framework/controls/loading";
export var competitorHasSubMembers = function (competitorType) {
    return [CompetitorType.Group, CompetitorType.Formation, CompetitorType.SmallTeam, CompetitorType.BigTeam, CompetitorType.Team].includes(competitorType);
};
export var getNamingOfCompetitorMember = function (competitorType) {
    if (competitorType === CompetitorType.Formation) {
        return 'formace';
    }
    if (competitorType === CompetitorType.SmallTeam || competitorType === CompetitorType.BigTeam) {
        return 'týmu';
    }
    if (competitorType === CompetitorType.Team) {
        return 'družstva';
    }
    if (competitorType === CompetitorType.Group) {
        return 'skupiny';
    }
    return '';
};
var getMemberCountMin = function (competitorType) {
    if (competitorType === CompetitorType.Group) {
        return 3;
    }
    if (competitorType === CompetitorType.SmallTeam) {
        return 3;
    }
    if (competitorType === CompetitorType.BigTeam) {
        return 13;
    }
    if (competitorType === CompetitorType.Formation) {
        return 12;
    }
    if (competitorType === CompetitorType.Team) {
        return 4;
    }
    return 0;
};
var getMemberCountMax = function (competitorType) {
    if (competitorType === CompetitorType.Group) {
        return 30;
    }
    if (competitorType === CompetitorType.SmallTeam) {
        return 12;
    }
    if (competitorType === CompetitorType.BigTeam) {
        return 30;
    }
    if (competitorType === CompetitorType.Formation) {
        return 16;
    }
    if (competitorType === CompetitorType.Team) {
        return 4;
    }
    return 0;
};
var getAllowedNumberOfAlternateMembers = function (competitorType) {
    if (competitorType === CompetitorType.Group) {
        return 9999;
    }
    if (competitorType === CompetitorType.SmallTeam) {
        return 9999;
    }
    if (competitorType === CompetitorType.BigTeam) {
        return 9999;
    }
    if (competitorType === CompetitorType.Formation) {
        return 2;
    }
    if (competitorType === CompetitorType.Team) {
        return 9999;
    }
    return 0;
};
var getAllowedNumberOfOlderMembers = function (competitorType, numberOfRegularMembers) {
    if (competitorType === CompetitorType.Group) {
        return getAllowedNumberOfOlderPeopleInGroup(numberOfRegularMembers);
    }
    if (competitorType === CompetitorType.SmallTeam) {
        return getAllowedNumberOfOlderPeopleInGroup(numberOfRegularMembers);
    }
    if (competitorType === CompetitorType.BigTeam) {
        return getAllowedNumberOfOlderPeopleInGroup(numberOfRegularMembers);
    }
    if (competitorType === CompetitorType.Formation) {
        return 0;
    }
    if (competitorType === CompetitorType.Team) {
        return 0;
    }
    return 0;
};
var getAllowedAgeIds = function (competitorType, competitionAgeId, championshipException) {
    if (competitorType === CompetitorType.Formation || competitorType === CompetitorType.Team) {
        return getAllowedAgeIdsForTeamOrFormationMembers(competitionAgeId);
    }
    if (competitorType === CompetitorType.SmallTeam || competitorType === CompetitorType.BigTeam) {
        return getAllowedAgeIdsForGroupMembers(competitionAgeId, false, championshipException);
    }
    if (competitorType === CompetitorType.Group) {
        return getAllowedAgeIdsForGroupMembers(competitionAgeId, championshipException, false);
    }
    return [];
};
var getAllowedOlderAgeIds = function (competitorType, competitionAgeId) {
    if ([CompetitorType.SmallTeam, CompetitorType.BigTeam, CompetitorType.Group].includes(competitorType)) {
        return getAllowedOlderAgeIdsForGroupMembers(competitionAgeId);
    }
    return [];
};
var getAvailableAttendees = function () {
    var _a;
    var state = useCompetitionRegistration()[0];
    var forTeam = state.groupMembersState.competitorType === CompetitorType.Team;
    var competitionState = state.competitionStates.find(function (c) { return c.entity.competitionId === state.groupMembersState.competitionId; });
    var championshipException = competitionState !== undefined ? ((_a = competitionState.entity) === null || _a === void 0 ? void 0 : _a.typeId) === CompetitionType.Championship : false;
    var allowedAgeIds = getAllowedAgeIds(state.groupMembersState.competitorType, state.groupMembersState.competitionAgeId, championshipException);
    var competitorTypeToFilter = forTeam ? CompetitorType.Couple : CompetitorType.SoloDancer;
    return state.attendees
        .filter(function (c) { return c.type === competitorTypeToFilter && c.name.substring(0, 1) !== '*' && c.competitorId !== undefined && c.competitorId !== null; })
        .filter(function (c) { return allowedAgeIds.includes(c.competitorAge); });
};
var ListOfAvailableAthletes = function (props) {
    var _a = useCompetitionRegistration(), state = _a[0], actions = _a[1];
    var competitorNaming = getNamingOfCompetitorMember(state.groupMembersState.competitorType);
    var allowedOlderAgeIds = getAllowedOlderAgeIds(state.groupMembersState.competitorType, state.groupMembersState.competitionAgeId);
    var arrayOfCurrentGroupMemberCompetitorIds = state.groupMembersState.collection_modified.map(function (m) { return m.componentCompetitorId; });
    var attendees = getAvailableAttendees();
    var currentlyIsGroupMember = function (competitorId) {
        return arrayOfCurrentGroupMemberCompetitorIds.includes(competitorId);
    };
    var disabled = state.groupMembersState.loading || state.groupMembersState.updating;
    return React.createElement(VBox, { className: [cls_width_column_available_athletes, cls_gap_form, cls_align_items_flex_start, cls_overflowY_auto, cls_list_height] },
        attendees.map(function (c) {
            var _a;
            var currentlyAssigned = currentlyIsGroupMember(c.competitorId);
            var isOlder = allowedOlderAgeIds.includes(c.competitorAge);
            var assignmentCheckboxDisabled = disabled || (!currentlyAssigned && false);
            var errors = (_a = state.groupMembersState.errors["components[".concat(c.competitorId, "]")]) === null || _a === void 0 ? void 0 : _a.errors;
            return React.createElement(VBox, { key: c.key, className: [cls_align_items_flex_start] },
                React.createElement(HBox, null,
                    React.createElement(VBox, { className: cls_width_checkbox },
                        React.createElement(Checkbox, { label: null, getter: function () { return currentlyAssigned; }, setter: function () { return actions.setGroupMemberAssignment(c.competitorId, !currentlyIsGroupMember(c.competitorId)); }, disabled: assignmentCheckboxDisabled })),
                    React.createElement(VBox, { className: [cls_width_athlete_name, useif(!isOlder, cls_bold)] }, "".concat(c.name))),
                errors && currentlyAssigned && React.createElement(HBox, { className: [cls_colorMagenta60, cls_width_column_available_athletes_item] }, toSingleString(errors)));
        }),
        attendees.length === 0 && React.createElement(HBox, { className: cls_width_column_available_athletes_item }, "Nem\u00E1te \u017E\u00E1dn\u00E9 sout\u011B\u017E\u00EDc\u00ED pro danou v\u011Bkovou kategorii ".concat(competitorNaming, ".")));
};
var ListOfAssignedAthletes = function (props) {
    var _a = useCompetitionRegistration(), state = _a[0], actions = _a[1];
    var allowedOlderAgeIds = getAllowedOlderAgeIds(state.groupMembersState.competitorType, state.groupMembersState.competitionAgeId);
    var attendees = state.attendees;
    var memberIdentifications = state.groupMembersState.collection_modified;
    var sortedMemberIdentifications = memberIdentifications.filter(function (e) { return true; }).sort(function (a, b) {
        var a_member = attendees.find(function (at) { return at.competitorId === a.componentCompetitorId; });
        var b_member = attendees.find(function (at) { return at.competitorId === b.componentCompetitorId; });
        return ((a_member === null || a_member === void 0 ? void 0 : a_member.name) || '').localeCompare((b_member === null || b_member === void 0 ? void 0 : b_member.name) || '');
    });
    var loading = state.groupMembersState.loading;
    var updating = state.groupMembersState.updating;
    var loadingTooLong = state.groupMembersState.loadingTooLong;
    var loadFailure = state.groupMembersState.loadFailure;
    var showContent = !loading && !loadFailure;
    var disabled = loading || updating;
    return React.createElement(VBox, { className: [cls_width_column_group_members_list, cls_gap_form, cls_align_items_flex_start, cls_overflowY_auto, cls_list_height] },
        showContent && React.createElement(React.Fragment, null, sortedMemberIdentifications.map(function (m) {
            var _a;
            var athlete = attendees.find(function (a) { return a.competitorId === m.componentCompetitorId; });
            var isOlder = allowedOlderAgeIds.includes(athlete === null || athlete === void 0 ? void 0 : athlete.competitorAge);
            var errors = (_a = state.groupMembersState.errors["components[".concat(m.componentCompetitorId, "]")]) === null || _a === void 0 ? void 0 : _a.errors;
            return React.createElement(VBox, { key: m.componentCompetitorId, className: [cls_align_items_flex_start] },
                React.createElement(HBox, { className: null },
                    React.createElement(VBox, { className: [cls_width_athlete_name, useif(!isOlder, cls_bold)] }, "".concat((athlete === null || athlete === void 0 ? void 0 : athlete.name) || '???')),
                    React.createElement(VBox, { className: [cls_width_column_backup, cls_align_items_center] },
                        React.createElement(Checkbox, { label: null, getter: function () { return m.backup === true; }, setter: function () { return actions.setGroupMemberBackupValue(m.componentCompetitorId, !m.backup); }, disabled: disabled })),
                    React.createElement(VBox, { className: cls_width_delete },
                        React.createElement(ButtonMinus, { onClick: function () { return actions.setGroupMemberAssignment(m.componentCompetitorId, false); }, intent: Intent.NotAction, disabled: disabled }))),
                errors && React.createElement(HBox, { className: [cls_colorMagenta60, cls_width_column_group_members_list_item] }, toSingleString(errors)));
        })),
        !showContent && loadingTooLong && React.createElement(LoadingSpinner, null));
};
var NumbersOfGroupMembers = function (props) {
    var competitorNaming = getNamingOfCompetitorMember(props.competitorType);
    var numberOfRegularMembers = props.numberOfRegularMembers;
    var numberOfOlderRegularMembers = props.numberOfOlderRegularMembers;
    var numberOfAlternateMembers = props.numberOfAlternateMembers;
    var sklonovaniClenu = function (num) {
        if (num === 1) {
            return 'člen';
        }
        if (num >= 2 && num <= 4) {
            return 'členové';
        }
        return 'členů';
    };
    var sklonovaniNahradniku = function (num) {
        if (num === 1) {
            return 'náhradník';
        }
        if (num >= 2 && num <= 4) {
            return 'náhradníci';
        }
        return 'náhradníků';
    };
    var sklonovaniVybrano = function (num) {
        if (num === 1) {
            return 'Vybrán';
        }
        if (num >= 2 && num <= 4) {
            return 'Vybráni';
        }
        return 'Vybráno';
    };
    return React.createElement(VBox, { className: [cls_flex_fixed_size, cls_gap_form, cls_align_items_flex_start] },
        React.createElement(HBox, null, "".concat(sklonovaniVybrano(numberOfRegularMembers), " ").concat(numberOfRegularMembers, " ").concat(sklonovaniClenu(numberOfRegularMembers), " ").concat(competitorNaming).concat(numberOfAlternateMembers > 0 ? " a ".concat(numberOfAlternateMembers, " ").concat(sklonovaniNahradniku(numberOfAlternateMembers)) : '', ".")),
        numberOfOlderRegularMembers > 0 && React.createElement(HBox, null, "".concat(numberOfOlderRegularMembers, " ").concat(sklonovaniClenu(numberOfOlderRegularMembers), " ").concat(competitorNaming, " ").concat(numberOfOlderRegularMembers >= 2 ? 'jsou' : 'je', " o kategorii star\u0161\u00ED").concat(numberOfOlderRegularMembers >= 5 ? 'ch' : '', ".")));
};
export var GroupOrFormationMembersDialog = function (props) {
    var _a, _b, _c, _d;
    var _e = useCompetitionRegistration(), state = _e[0], actions = _e[1];
    var forFormation = state.groupMembersState.competitorType === CompetitorType.Formation;
    var competitorNaming = getNamingOfCompetitorMember(state.groupMembersState.competitorType);
    var memberCountMin = getMemberCountMin(state.groupMembersState.competitorType);
    var memberCountMax = getMemberCountMax(state.groupMembersState.competitorType);
    var competitionId = state.groupMembersState.competitionId;
    var groupCompetitorId = state.groupMembersState.groupCompetitorId;
    var toBeReloaded = state.groupMembersState.toBeReloaded;
    React.useEffect(function () {
        if (groupCompetitorId !== null && competitionId !== null) {
            actions.loadGroupMembers(groupCompetitorId, competitionId);
        }
    }, [groupCompetitorId, competitionId]);
    React.useEffect(function () {
        if (groupCompetitorId !== null && competitionId !== null && toBeReloaded) {
            actions.loadGroupMembers(groupCompetitorId, competitionId);
        }
    }, [toBeReloaded]);
    React.useEffect(function () {
        actions.hideGroupMembersDialog();
    }, []);
    var cancel = function () {
        actions.hideGroupMembersDialog();
    };
    var equalityOfMemberLists = function (memberList1, memberList2) {
        if ((memberList1 || []).length !== (memberList2 || []).length) {
            return false;
        }
        var equal = true;
        memberList1.forEach(function (m1) {
            if (equal) {
                var m2 = memberList2.find(function (e) { return e.componentCompetitorId === m1.componentCompetitorId; });
                if (m2 !== undefined) {
                    if (m1.backup !== m2.backup) {
                        equal = false;
                    }
                }
                else {
                    equal = false;
                }
            }
        });
        return equal;
    };
    var anyUnsavedChanges = !equalityOfMemberLists(state.groupMembersState.collection_modified, (_a = state.groupMembersState.entity) === null || _a === void 0 ? void 0 : _a.components) || state.groupMembersState.captain_modified !== ((_b = state.groupMembersState.entity) === null || _b === void 0 ? void 0 : _b.captain);
    var allowedOlderAgeIds = getAllowedOlderAgeIds(state.groupMembersState.competitorType, state.groupMembersState.competitionAgeId);
    var attendees = state.attendees;
    var memberIdentifications = state.groupMembersState.collection_modified;
    var groupRegularAthletes = memberIdentifications.filter(function (m) { return m.backup !== true; }).map(function (m) {
        return attendees.find(function (a) { return a.competitorId === m.componentCompetitorId; });
    });
    var numberOfRegularMembers = memberIdentifications.filter(function (m) { return m.backup !== true; }).length;
    var numberOfOlderRegularMembers = groupRegularAthletes.filter(function (a) { return allowedOlderAgeIds.includes(a === null || a === void 0 ? void 0 : a.competitorAge); }).length;
    var numberOfAlternateMembers = memberIdentifications.filter(function (m) { return m.backup === true; }).length;
    var allowedNumberOfOlderMembers = getAllowedNumberOfOlderMembers(state.groupMembersState.competitorType, numberOfRegularMembers);
    var allowedNumberOfAlternatemembers = getAllowedNumberOfAlternateMembers(state.groupMembersState.competitorType);
    var numberOfMembersCheckPassed = numberOfRegularMembers >= memberCountMin && numberOfRegularMembers <= memberCountMax;
    var numberOfOlderMembersCheckPassed = numberOfOlderRegularMembers <= allowedNumberOfOlderMembers;
    var numberOfAlternateMembersCheckPassed = numberOfAlternateMembers <= allowedNumberOfAlternatemembers;
    var saveAllowed = numberOfMembersCheckPassed && numberOfOlderMembersCheckPassed && numberOfAlternateMembersCheckPassed;
    var availableAttendees = getAvailableAttendees();
    var anyCompetitorError = availableAttendees.map(function (c) {
        var _a;
        return ((_a = state.groupMembersState.errors["components[".concat(c.competitorId, "]")]) === null || _a === void 0 ? void 0 : _a.errors) != null;
    }).filter(function (c) { return c === true; }).length > 0;
    var anyCaptainError = ((_c = state.groupMembersState.errors["captain"]) === null || _c === void 0 ? void 0 : _c.errors) != null;
    var globalErrors = (_d = state.groupMembersState.errors[""]) === null || _d === void 0 ? void 0 : _d.errors;
    var anyGlobalError = globalErrors != null;
    var anySavingErrors = anyCompetitorError || anyGlobalError || anyCaptainError;
    var setter_captain = function (field, value, validator, storeInvalidValue) {
        return actions.setCaptainField(value);
    };
    var loading = state.groupMembersState.loading;
    var updating = state.groupMembersState.updating;
    var loadingTooLong = state.groupMembersState.loadingTooLong;
    var loadFailure = state.groupMembersState.loadFailure;
    var showContent = !loading && !loadFailure;
    var disabled = loading || updating;
    return React.createElement(React.Fragment, null,
        React.createElement(Dialog, { open: state.groupMembersState.dialogIsVisible },
            React.createElement(DialogContent, null,
                React.createElement(DialogTitle, null, "\u010Clenov\u00E9 ".concat(competitorNaming)),
                React.createElement(VBox, { className: [cls_submembers_dialog_subcontent, cls_gap_form] },
                    React.createElement(HBox, { className: [cls_flex_fixed_size, cls_gap_form] },
                        React.createElement(VBox, { className: cls_width_column_available_athletes }, "dostupn\u00ED sout\u011B\u017E\u00EDc\u00ED*"),
                        React.createElement(VBox, { className: cls_1px_width }),
                        React.createElement(HBox, null,
                            React.createElement(VBox, { className: cls_width_athlete_name }, "\u010Dlenov\u00E9 ".concat(competitorNaming).concat(forFormation ? '' : '*')),
                            React.createElement(VBox, { className: cls_width_column_backup }, "n\u00E1hradn\u00EDk"))),
                    React.createElement(HBox, { className: [cls_flex_use_available_space, cls_gap_form] },
                        React.createElement(ListOfAvailableAthletes, null),
                        React.createElement(VBox, { className: cls_dialog_vertical_division_line }),
                        React.createElement(ListOfAssignedAthletes, null)),
                    React.createElement(NumbersOfGroupMembers, { numberOfRegularMembers: numberOfRegularMembers, numberOfAlternateMembers: numberOfAlternateMembers, numberOfOlderRegularMembers: numberOfOlderRegularMembers, competitorType: state.groupMembersState.competitorType }),
                    React.createElement(HBox, { className: [cls_flex_fixed_size, cls_justify_content_flex_end] },
                        React.createElement(VBox, { className: cls_width_captain },
                            React.createElement(TextField, { label: "Kapit\u00E1n", name: "captain", state: state.groupMembersState, getter: function () { return state.groupMembersState.captain_modified; }, setter: setter_captain }))),
                    globalErrors != null && !state.groupMembersState.updating && React.createElement(HBox, { className: [cls_flex_fixed_size, cls_colorMagenta60, cls_dialog_content_width] }, toSingleString(globalErrors)),
                    anySavingErrors && !state.groupMembersState.updating && React.createElement(HBox, { className: [cls_flex_fixed_size, cls_colorMagenta60, cls_dialog_content_width] }, anyCompetitorError ? "Upravená data nebyla kvůli uvedeným chybám uložena." : "Upravená data nebyla uložena."),
                    React.createElement(HBox, { className: [useif(loading, cls_visibility_hidden), cls_flex_fixed_size, cls_gap_form, cls_justify_content_space_between, cls_align_items_center, cls_dialog_content_width] },
                        React.createElement(HBox, null, saveAllowed
                            ? React.createElement(React.Fragment, null, anyUnsavedChanges && React.createElement(Button, { onClick: function () { return actions.saveGroupMembers(); }, disabled: disabled }, 'Uložit'))
                            : React.createElement(React.Fragment, null,
                                !numberOfMembersCheckPassed && React.createElement(VBox, { className: cls_colorOrange50 }, "Po\u010Det \u010Dlen\u016F ".concat(competitorNaming, " mus\u00ED b\u00FDt ").concat(memberCountMin < memberCountMax ? "v rozmez\u00ED ".concat(memberCountMin, " a\u017E ").concat(memberCountMax) : "".concat(memberCountMin), ".")),
                                numberOfMembersCheckPassed && !numberOfOlderMembersCheckPassed && !forFormation && React.createElement(VBox, { className: cls_colorOrange50 }, "Pro ".concat(numberOfRegularMembers, " \u010Dlen").concat(numberOfRegularMembers >= 5 ? 'ů' : 'y', " skupiny ").concat(allowedNumberOfOlderMembers === 1 || allowedNumberOfOlderMembers === 5 ? 'může' : 'mohou', " b\u00FDt maxim\u00E1ln\u011B ").concat(allowedNumberOfOlderMembers, " o kagetorii star\u0161\u00ED").concat(allowedNumberOfOlderMembers >= 2 ? 'ch' : '', ".")),
                                numberOfMembersCheckPassed && !numberOfAlternateMembersCheckPassed && React.createElement(VBox, { className: cls_colorOrange50 }, "Maxim\u00E1ln\u00ED po\u010Det n\u00E1hradn\u00EDk\u016F je ".concat(allowedNumberOfAlternatemembers, ".")))),
                        React.createElement(Button, { onClick: cancel, intent: Intent.NotAction, disabled: disabled }, anyUnsavedChanges ? 'Zavřít bez uložení změn' : 'Zavřít')),
                    allowedNumberOfOlderMembers > 0 && React.createElement(VBox, { className: [cls_flex_fixed_size, cls_p5r, cls_colorGrey90, cls_dialog_content_width] },
                        React.createElement(HBox, null,
                            React.createElement(HBox, { className: cls_asterisk_box }, "*"),
                            React.createElement(HBox, null, "Tu\u010Dn\u00FDm p\u00EDsmem jsou vyps\u00E1ni sout\u011B\u017E\u00EDc\u00ED, kte\u0159\u00ED vyhovuj\u00ED dan\u00E9 v\u011Bkov\u00E9 kategorii.")),
                        React.createElement(HBox, null,
                            React.createElement(HBox, { className: cls_asterisk_box }),
                            React.createElement(HBox, null, "B\u011B\u017En\u00FDm p\u00EDsmem jsou vyps\u00E1ni sout\u011B\u017E\u00EDc\u00ED o kategorii star\u0161\u00ED.")))))));
};
